import {
  SET_PAGE,
  SET_ROWS_PER_PAGE,
  SORT_COLUMNS_BY } from 'src/vuex/mutation-type'
// import formSchema from 'src/schema/form'
import _ from 'lodash'

// initial state
const state = {
  page: '1',
  rowsPerPage: '20',
  sortColumns: []
}

// mutations
const mutations = {
  [SET_PAGE] (state, page) {
    state.page = page
  },
  [SET_ROWS_PER_PAGE] (state, num) {
    state.rowsPerPage = num
  },
  [SORT_COLUMNS_BY] (state, identity) {
    // sort already exist
    let index = _.findIndex(state.sortColumns, identity)
    if (index > -1) {
      if (state.sortColumns[index][identity] === 'ASC') {
        state.sortColumns.splice(index, 1, {[identity]: 'DESC'})
      } else {
        state.sortColumns.splice(index, 1)
      }
    } else {
      state.sortColumns.push({
        [identity]: 'ASC'
      })
    }
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/table.js